module.exports = "/assets/_next/static/images/clouds-left-d506be2fce8f8015427517edf6e7145b.png";